import React from "react";
import {
  ShieldCheck, LayoutGrid, Box, FileText, Settings as SettingsIcon, Zap, CheckCircle2,
  XCircle, AlertTriangle, Lock, Plus, ChevronRight, ChevronLeft, X, User, Trash2,
  Wrench, GraduationCap, AlertCircle, Gauge, CheckCheck, BarChart3, CreditCard, QrCode,
  Tag, MessageCircle, Gift, Calendar, AlarmClock, CloudOff, RefreshCw, Play, Ban, Camera,
  Send, Info, ExternalLink, Rocket, Layers, Search, Download, Mail, Grid3x3, Clock,
  PartyPopper, Cog, Clipboard, FolderOpen, LogOut, Mic, Check,
  Building2, Users, Shield, Server, Eye, Pencil, Image as ImageIcon,
  UtensilsCrossed, Thermometer, Snowflake, Flame, Sun, Moon, Sparkles,
} from "lucide-react";

const MAP = {
  "shield-checkmark": ShieldCheck, grid: LayoutGrid, cube: Box, "document-text": FileText,
  settings: SettingsIcon, flash: Zap, "checkmark-circle": CheckCircle2, "close-circle": XCircle,
  warning: AlertTriangle, "lock-closed": Lock, add: Plus, "chevron-forward": ChevronRight,
  "chevron-back": ChevronLeft, close: X, person: User, trash: Trash2, "trash-outline": Trash2,
  construct: Wrench, "construct-outline": Wrench, school: GraduationCap, "school-outline": GraduationCap,
  "alert-circle": AlertCircle, speedometer: Gauge, "speedometer-outline": Gauge,
  "checkmark-done": CheckCheck, "stats-chart": BarChart3, card: CreditCard, "qr-code": QrCode,
  pricetag: Tag, "chatbubble-ellipses": MessageCircle, gift: Gift, calendar: Calendar,
  alarm: AlarmClock, "cloud-offline": CloudOff, sync: RefreshCw, play: Play, ban: Ban,
  camera: Camera, "paper-plane": Send, "information-circle": Info, "open-outline": ExternalLink,
  rocket: Rocket, layers: Layers, search: Search, download: Download, mail: Mail, grid2: Grid3x3,
  time: Clock, balloon: PartyPopper, "balloon-outline": PartyPopper, cog: Cog,
  "clipboard-outline": Clipboard, "folder-open-outline": FolderOpen, "logout": LogOut,
  mic: Mic, checkmark: Check, business: Building2, people: Users, shield: Shield, server: Server,
  document: FileText, "cube-outline": Box, eye: Eye, create: Pencil, image: ImageIcon,
  restaurant: UtensilsCrossed, "restaurant-outline": UtensilsCrossed, thermometer: Thermometer,
  snow: Snowflake, flame: Flame, sunny: Sun, moon: Moon, sparkles: Sparkles,
};

export default function Icon({ name, size = 20, color = "#fff", style }) {
  const Cmp = MAP[name] || Info;
  return <Cmp size={size} color={color} style={style} strokeWidth={2.4} />;
}
